module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/61602e599e63650a59b2a3d23b802307.png";